import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Inject, Injector, ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoadingService } from '../../shared/loading/loading.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { IConfirmConfig } from '../../shared/confirm/confirm.config';
import { AuthService } from './auth.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {

    constructor(@Inject(Injector) private injector: Injector) {
        super();
    }

    handleError(error) {
        if (error instanceof HttpErrorResponse) {
            this.loading.setLoading(false);

            switch (error.status) {
                case 401:
                    this.translateService.get(['labels.aceptar', 'messages.sesionCaducada']).subscribe((res) => {
                        const confirmConfig: IConfirmConfig = {
                            title: ' ',
                            message: res['messages.sesionCaducada'],
                            textButtonAccept: res['labels.aceptar'],
                            onButtonAccept: () => {
                                if (this.router.url !== '/login') {
                                    this.authService.logout();
                                }
                            }
                        };
                        this.confirm.confirmConfig = confirmConfig;
                        this.confirm.showConfirm(true);
                    });
                    break;
                case 500:
                case 413:
                    this.translateService.get('messages.errorGenerico').subscribe((res) => {
                        this.toastrService.error(res, error.status.toString(), {
                            closeButton: true,
                            timeOut: 5000,
                            onActivateTick: true
                        });
                    });

                    break;

                default:
                    const e = error.error.Warning ? error.error.Warning.Title : error.error.ErrorMessage;
                    const code = error.status ? error.status : error.error.ErrorCode ? error.error.ErrorCode : '';
                    this.toastrService.error(e, code.toString(), {
                        closeButton: true,
                        timeOut: 5000,
                        onActivateTick: true
                    });
                    break;
            }

        }
        super.handleError(error);
    }

    private get toastrService(): ToastrService {
        return this.injector.get(ToastrService);
    }

    private get translateService(): TranslateService {
        return this.injector.get(TranslateService);
    }

    private get authService(): AuthService {
        return this.injector.get(AuthService);
    }

    private get router(): Router {
        return this.injector.get(Router);
    }

    private get loading(): LoadingService {
        return this.injector.get(LoadingService);
    }

    private get confirm(): ConfirmService {
        return this.injector.get(ConfirmService);
    }

}
